<section class="file-uploader block pb-4">
  <!-- Contenido personalizado antes del input -->
  <ng-content select="[select-file]"></ng-content>

  <!-- Zona de subida de archivos -->
  <div class="c-form-group relative border-4 border-dashed border-gray-200 p-3 mb-3 rounded-lg w-100">
    <input
      class="absolute top-0 right-0 bottom-0 left-0 w-full opacity-0 cursor-pointer"
      #calificationFile
      id="calification-file"
      name="calification-file"
      type="file"
      (change)="addFiles($event)"
      [accept]="accept"
      [multiple]="multi" />
    <div>
      <button class="c-button c-button--sm">{{ label }}</button>
      <span>{{ grabLabel }}</span>
    </div>
  </div>

  <!-- Lista de archivos -->
  <div *ngFor="let uFile of localFiles; let i = index" class="mb-3">
    <desy-item [icon]="{ html: fileIcon }" [caller]="removeButton">
      <desy-title>{{ uFile.file.name }}</desy-title>
    </desy-item>

    <ng-template #removeButton>
      <button
        class="c-button c-button--sm c-button--transparent"
        (click)="removeFile(i)">
        Eliminar
      </button>
    </ng-template>

    <!-- Vista previa -->
    <div class="preview-box border rounded mt-2 p-2 bg-gray-50">
      <!-- Imagen -->
      <img
        *ngIf="isImage(uFile.file)"
        [src]="uFile.preview"
        class="w-full h-64 object-contain rounded"
      />

      <!-- PDF -->
      <iframe
        *ngIf="uFile.type === 'pdf'"
        [src]="uFile.preview"
        class="w-full h-96 border-none rounded"
        title="Vista previa PDF">
      </iframe>

      <!-- TXT -->
      <pre
        *ngIf="uFile.type === 'txt'"
        class="p-2 bg-white rounded border text-sm whitespace-pre-wrap">
        {{ uFile.textContent }}
      </pre>

      <!-- DOCX -->
      <div *ngIf="uFile.type === 'docx'" class="p-2 bg-gray-200 rounded text-sm overflow-auto max-h-64">
        <pre class="whitespace-pre-wrap break-words">{{ uFile.textContent }}</pre>
      </div>

      <!-- DOC -->
      <div *ngIf="uFile.type === 'doc'" class="p-2 bg-gray-200 rounded text-sm">
      <pre>{{ uFile.textContent }}</pre>
    </div>
    </div>
  </div>
</section>
